import React from 'react';
import {
  Dimmer,
  Loader,
} from 'semantic-ui-react';

const LoadingIndicator = () => (
  <Dimmer active inverted>
    <Loader size="massive" />
  </Dimmer>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./app/components/LoadingIndicator/index.js